{
  "publish.action.export": "Export",
  "publish.action.publish": "Publish",
  "publish.action.sync": "Sync",
  "publish.action.upgrade": "Upgrade",
  "publish.dns.cname": "CNAME",
  "publish.dns.step1": "1. Go to your DNS manager for ",
  "publish.dns.step2": "2. Create A records:",
  "publish.dns.step3": "3. Create TXT record:",
  "publish.domains.custom": "Custom domain",
  "publish.domains.customHint": "Connect any domain to your app",
  "publish.domains.find": "Find your domain",
  "publish.domains.findHint": "Connect to a new domain",
  "publish.domains.management": "Domain management",
  "publish.domains.name": "Domain name",
  "publish.domains.needApiKey": "Enter your API key above to enable domain search.",
  "publish.domains.noResults": "No results. Try a different query.",
  "publish.domains.register": "Register",
  "publish.domains.renews": "renews {date}",
  "publish.domains.searching": "Searching…",
  "publish.domains.taken": "taken",
  "publish.domains.title": "Domains",
  "publish.domains.yours": "Your domains",
  "publish.envs.development": "Development",
  "publish.envs.developmentHint": "Default - set to latest",
  "publish.envs.local": "Local",
  "publish.envs.production": "Production",
  "publish.envs.productionHint": "Specify production channel",
  "publish.envs.staging": "Staging",
  "publish.envs.test": "Test",
  "publish.envs.testHint": "Specify staging channel",
  "publish.envs.title": "Environments",
  "publish.exports.download": "Download export",
  "publish.exports.html.descr": "Download pre-rendered HTML",
  "publish.exports.jquery.descr": "Download files with jQuery runner",
  "publish.exports.local.descr": "Download as local Javascript files",
  "publish.exports.local.title": "Local files",
  "publish.exports.react.descr": "Download files with React runner",
  "publish.exports.svg.descr": "Download files with React runner",
  "publish.exports.webp.descr": "Download files with jQuery runner",
  "publish.modal.confirm": "Confirm publish",
  "publish.modal.confirmAgain": "Click \"Publish\" again to confirm.",
  "publish.modal.otherPaths": "Other changed paths:",
  "publish.sync.autosync": "Autosync",
  "publish.sync.autosyncHint": "Enable auto syncing during publishing",
  "publish.sync.connect": "Connect",
  "publish.sync.figma.descr": "Import tokens, layers and artboards",
  "publish.sync.github.descr": "Sync with your repository",
  "publish.sync.website.descr": "Import tokens, layers and artboards",
  "publish.sync.website.title": "Your website",
  "publish.sync.wordpress.descr": "Sync Symbols components",
  "publish.tools.autosaved": "Autosaved",
  "publish.tools.latest": "Latest",
  "publish.tools.showVersions": "Show versions",
  "publish.tools.updateMajor": "Update Major",
  "publish.tools.updateMinor": "Update Minor"
}
